import { allRudderMetricNames } from '@shared_types/metrics/rudder_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_RUDDER, UPDATE_RUDDER } from '../actions'

const initialState = initializeMetrics(allRudderMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_RUDDER || type === UPDATE_RUDDER) {
    console.log('init rudder', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
